// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import { teacupWithHelpers } from 'app/scripts/views/internal/teacupWithHelpers';
const t = teacupWithHelpers('popover_helper_new_board_add_org');

export const PopoverHelperNewBoardAddOrgTemplate = () => {
  t.p(() =>
    t.format(
      'an-organization-is-a-collection-of-members-and-boards-they-make-sharing-and-working-within-a-group-even-easier',
    ),
  );

  return t.a('.button.js-create-org', { href: '#' }, () =>
    t.format('create-an-organization'),
  );
};
